import {
    SET_LANGUAGE,
    SET_DIRECTION,
    SET_COUNTRY_POPUP
  } from '../types/types';
  
  export const setLanguage = (value) => {
    return {
      type: SET_LANGUAGE,
      payload: { data: value },
    };
  };
  
  export const setDirection = (value) => {
    return {
      type: SET_DIRECTION,
      payload: { data: value },
    };
  };

  export const setCountryPopup = (value) => {
    return {
      type: SET_COUNTRY_POPUP,
      payload: { data: value },
    };
  };